// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__3VI2n","noInteraction":"EventWrapper_noInteraction__lBM3C","pointerPassthrough":"EventWrapper_pointerPassthrough__6TjhG"};